import { Box } from "@mui/material";
import { Pill } from "@src/appV2/redesign/system/ui-components";

interface PlacementRecentlyAddedPillProps {
  blurred?: boolean;
}

export function PlacementRecentlyAddedPill(props: PlacementRecentlyAddedPillProps) {
  const { blurred = false } = props;

  return (
    <Pill
      iconType="new"
      label={
        <Box component="span" style={{ filter: blurred ? "blur(8px)" : undefined }}>
          New
        </Box>
      }
      variant="filled"
      size="small"
      backgroundColor={(theme) => theme.palette.intent?.neutral.background}
      color={(theme) => theme.palette.intent?.neutral.text}
    />
  );
}
